import React, { useReducer } from 'react';

import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';

import { noop } from 'helpers';
import { device } from 'helpers/screenSizes';
import { useTheme } from 'hooks';
import { MaterialDialog } from 'UIKit';

import { SLIDES_DATA } from './constants';
import OptionsCombosDesktopSlide from './Desktop/desktopSlides';
import OptionsCombosMobileSlide from './Mobile/mobileSlides';

interface OptionsCombosSlidesType {
  isModalOpen: boolean;
  handleModalClose: Function;
}

const initialState = {
  activeSlideId: 1,
  buttonText: '',
};

const reducer = (prevState, state) => ({ ...prevState, ...state });

const OptionsCombosSlides = ({
  isModalOpen,
  handleModalClose,
}: OptionsCombosSlidesType) => {
  const { t } = useTranslation(['trading']);
  const { activeTheme } = useTheme();

  const [state, updateState] = useReducer(reducer, initialState, initialStateDefault => ({
    ...initialStateDefault,
    buttonText: t('trading:options_combos_slides.next'),
  }));
  const { activeSlideId, buttonText } = state;

  const handleNextClick = (_, { id }) => {
    if (id === SLIDES_DATA.length) {
      return handleModalClose();
    }

    const updatedActiveSlideId = id + 1;
    if (id === SLIDES_DATA.length - 1) {
      return updateState({
        buttonText: t('trading:options_combos_slides.finish'),
        activeSlideId: updatedActiveSlideId,
      });
    }
    return updateState({ activeSlideId: updatedActiveSlideId });
  };

  const activeSlide = SLIDES_DATA.find(slideDatumn => slideDatumn.id === activeSlideId);

  const totalCount = SLIDES_DATA.length;

  const activeSlideTranslationData = t(`trading:options_combos_slides.slide_data`, {
    returnObjects: true,
  });

  const activeSlideTranslationDatumn =
    activeSlideTranslationData[activeSlide?.identifier];

  const activeSlideDatumn = {
    ...activeSlide,
    file_name: `${activeSlide?.file_name}-${activeTheme}`,
    ...activeSlideTranslationDatumn,
  };

  return (
    <MaterialDialog open={isModalOpen} onClose={noop} darkOverlay>
      <MediaQuery query={device.up.md}>
        <OptionsCombosDesktopSlide
          activeSlide={activeSlideDatumn}
          handleModalClose={handleModalClose}
          handleNextClick={handleNextClick}
          totalCount={totalCount}
          buttonText={buttonText}
        />
      </MediaQuery>
      <MediaQuery query={device.down.md}>
        <OptionsCombosMobileSlide
          activeSlide={activeSlideDatumn}
          handleModalClose={handleModalClose}
          handleNextClick={handleNextClick}
          totalCount={totalCount}
          buttonText={buttonText}
        />
      </MediaQuery>
    </MaterialDialog>
  );
};

export default OptionsCombosSlides;
